import { EDIT_USER } from './../const/index'

export const userLoginReducer = (state: any, action: any) => {
    switch (action.type) {
        case `${EDIT_USER}_SUCCESS`: {
            return {
                ...state,
                value: {
                    ...state.value,
                    user: {
                        ...state.value.user,
                        ...action.payload.result
                    },
                },
            }
        }
        default: {
            return state
        }
    }
}
